import { toast } from 'react-hot-toast';

// A regular toast.success() call only survives client-side navigation
// (router.push) because the global <Toaster/> in _app.tsx stays mounted.
// A hard navigation (window.location.href) tears down the whole JS runtime,
// so nothing in memory — including the toast — makes it across. Queue the
// message in sessionStorage instead and flush it once the next page mounts.
const STORAGE_KEY = 'epen_pending_toast';

type QueuedToastType = 'success' | 'error';

interface QueuedToast {
  type: QueuedToastType;
  message: string;
}

export const queueToast = (type: QueuedToastType, message: string): void => {
  if (typeof window === 'undefined') return;

  const queued: QueuedToast = { type, message };

  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(queued));
  } catch {
    // sessionStorage unavailable (private mode, etc.) - nothing to fall back to.
  }
};

export const flushQueuedToast = (): void => {
  if (typeof window === 'undefined') return;

  let raw: string | null = null;
  try {
    raw = window.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return;
  }

  if (!raw) return;

  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }

  try {
    const queued: QueuedToast = JSON.parse(raw);
    if (queued.type === 'error') {
      toast.error(queued.message);
    } else {
      toast.success(queued.message);
    }
  } catch {
    // malformed payload - drop it silently.
  }
};
